module.exports = __webpack_public_path__ + "static/media/GabesJanvier.72995d08.jpg";